import { IonBackButton, IonButtons, IonMenuButton, IonTitle, IonToolbar } from '@ionic/react';
import { RouteNames } from '../../models/routes.model';

import ProfileChip from '../profileChip/ProfileChip';
import { IonHeaderWrapper } from './ProfileHeader.styles';

interface IComponentProps {
  title: string;
  backButton?: boolean;
}

const ProfileHeader: React.FC<IComponentProps> = ({ title, backButton }) => {
  return (
    <IonHeaderWrapper color="lightest">
      <IonToolbar color="primary">
        <IonButtons slot="start">
          {backButton && <IonBackButton defaultHref={RouteNames.dashboard} color="secondary" />}
          {!backButton && <IonMenuButton color="secondary" />}
        </IonButtons>
        <IonTitle>{title}</IonTitle>
        <ProfileChip slot="end" />
      </IonToolbar>
    </IonHeaderWrapper>
  );
};

export default ProfileHeader;
